import { useConnectModal, useOpenModal } from '@rainbow-modules/hooks';
import { EDIT_SIP_USER_DRAWER } from '../../../../../constants';
import { StyledDrawer } from './styled';
import EditSipUserForm from './EditSipUserForm';

const EditSipUserDrawer = () => {
    const connectedProps = useConnectModal(
        EDIT_SIP_USER_DRAWER,
        { size: 'small', slideFrom: 'right' },
    );
    const [, closeDrawer] = useOpenModal(EDIT_SIP_USER_DRAWER);
    const {
        initialValues,
        onSubmit,
        ...drawerProps
    } = connectedProps;

    return (
        <StyledDrawer
            {...drawerProps}
            onRequestClose={closeDrawer}
        >
            <EditSipUserForm
                initialValues={initialValues as { friendlyName?: string }}
                onRequestClose={closeDrawer}
                onSubmit={onSubmit as (values: { friendlyName?: string }) => Promise<void>}
            />
        </StyledDrawer>
    );
};

export default EditSipUserDrawer;
